import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import withInit from 'WithInit';
import { connect } from 'react-redux';
import classnames from 'classnames';
import SignatureDeclineModal from './SignatureDeclineModal';

class SignatureDeclineButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isDeclineModalVisible: false,
    };

    this.showDeclineModal = this.showDeclineModal.bind(this);
    this.hideDeclineModal = this.hideDeclineModal.bind(this);
    this.trackDeclineAction = this.trackDeclineAction.bind(this);
    this.trackFreewriteAction = this.trackFreewriteAction.bind(this);
  }

  showDeclineModal() {
    if (this.props.onDecline) {
      this.props.onDecline();
    }
    this.trackDeclineAction('Decline');
    this.setState({
      isDeclineModalVisible: true,
    });
  }

  hideDeclineModal() {
    this.trackDeclineAction('Cancel Decline');
    this.setState({
      isDeclineModalVisible: false,
    });
  }

  trackFreewriteAction(trackingAction) {
    const { documentType } = this.props;
    if (window.User.isLoggedIn) {
      window._track(`Request Signature | ${trackingAction}`, `${documentType} | Freewrite-Builder-Member`);
    } else {
      window._track(`Request Signature | ${trackingAction}`, `${documentType} | Freewrite-Builder`);
    }
  }

  trackDeclineAction(actionType = '') {
    let trackingAction = actionType;
    if (!trackingAction) {
      trackingAction = this.props.confirmationTracking;
    }

    if (this.props.isFreewrite) {
      this.trackFreewriteAction(trackingAction);
    } else {
      window._track(`${trackingAction} | Recipient Builder`, 'Recipient Builder');
    }
  }

  render() {
    if (this.props.didAcceptTerms) return null;
    const declineClasses = classnames(
      'ds-btn-tertiary recipient-decline-button',
      {
        white: this.props.useWhiteText,
      },
    );
    return (
      <Fragment>
        <button
          aria-labelledby="contained-modal-title-vcenter"
          className={declineClasses}
          onClick={this.showDeclineModal}
          type="button"
        >
          Decline
        </button>
        <SignatureDeclineModal
          closeModal={this.hideDeclineModal}
          isOpen={this.state.isDeclineModalVisible}
          isFreewrite={this.props.isFreewrite}
          onCancel={this.props.onCancel}
          onConfirmDecline={this.props.onConfirmDecline}
          shareKey={this.props.shareKey}
          trackDeclineAction={this.trackDeclineAction}
        />
        {this.props.isTermsOfServiceBannerVisible && (
          <div className="terms-of-service-error-banner">
            <b>Important!&nbsp;</b>
            Please agree or decline to the Terms of Service.
          </div>
        )}
      </Fragment>
    );
  }
}

SignatureDeclineButton.propTypes = {
  confirmationTracking: PropTypes.string,
  didAcceptTerms: PropTypes.bool.isRequired,
  documentType: PropTypes.string.isRequired,
  isFreewrite: PropTypes.bool,
  isTermsOfServiceBannerVisible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onConfirmDecline: PropTypes.func,
  onDecline: PropTypes.func,
  shareKey: PropTypes.string.isRequired,
  useWhiteText: PropTypes.bool,
};

SignatureDeclineButton.defaultProps = {
  confirmationTracking: 'Confirm Decline',
  isFreewrite: false,
  onCancel: null,
  onConfirmDecline: null,
  onDecline: null,
  useWhiteText: true,
};

const mapStateToProps = ({ RequestSignatureReducer }) => ({
  didAcceptTerms: RequestSignatureReducer.didAcceptTerms,
  isTermsOfServiceBannerVisible: RequestSignatureReducer.isTermsOfServiceBannerVisible,
});

export const SignatureDeclineButtonWithRedux = connect(
  mapStateToProps,
)(SignatureDeclineButton);

export default withInit(SignatureDeclineButtonWithRedux, true);



// WEBPACK FOOTER //
// ./src-react/SignatureDeclineButton/index.jsx